import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import Breadcrumb from '../components/Breadcrumb';
import { useSearchParams } from 'react-router-dom';
import { useFetch } from '../hook/useFecth';
import ClientesListLayer from '../components/ClientesListLayer';
import ProdutosListLayer from '../components/ProdutosListLayer';
import PedidosListLayer from '../components/PedidosListLayer';

const PedidosListPage = () => {
    const [searchParams] = useSearchParams();
    const { data, mutate } = useFetch(`/pedido`, { params: { ...Object.fromEntries([...searchParams]) } });
    return (
        <>
            {/* Breadcrumb */}
            <Breadcrumb title="Pedidos" icon="solar:cart-large-2-outline" />

            {/* UsersListLayer */}
            <PedidosListLayer data={data} mutate={mutate} />
        </>
    );
};

export default PedidosListPage;
